import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

// material-ui components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { StyleRulesCallback, withStyles } from '@material-ui/core/styles';
// material-ui icons
import CreditCardIcon from '@material-ui/icons/CreditCard';
import DashboardIcon from '@material-ui/icons/Dashboard';
import LockIcon from '@material-ui/icons/Lock';
import BusinessIcon from '@material-ui/icons/Business';
import BillingIcon from '@material-ui/icons/EuroSymbol';
import { isAdmin, isAssetManager, isBillingAdmin } from '../../auth/identityAuth';
import AppsIcon from '@material-ui/icons/Apps';
import ChatIcon from '@material-ui/icons/Chat';
import HealingIcon from '@material-ui/icons/Healing'
import PeopleIcon from '@material-ui/icons/People';

import { bindActionCreators } from 'redux';
import { loadSubscriptionRequestStart, loadSubscriptionRequestsSuccess } from '../../actions/subscriptionRequestActions'
import store from '../../store';

const DashboardLink = (props: any) => <NavLink to="/" {...props} />
const DatamanagementLink = (props: any) => <NavLink to="/providerassets/" {...props} />
const SubscriptionLink = (props: any) => <NavLink to="/subscriptions/" {...props} />
const VerificationLink = (props: any) => <NavLink to="/verifications/" {...props} />
const OrganizationLink = (props: any) => <NavLink to="/organization/settings/" {...props} />
const CommunitiesLink = (props: any) => <NavLink to="/community-management" {...props} />
const BillingLink = (props: any) => <NavLink to="/billing/" {...props} />
const styles: StyleRulesCallback = (theme: any) => ({
  root: {
    height: 100,
  },
  indent: {
    paddingLeft: 40
  },
  filler: {
    flexGrow: 1
  },
  nav: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    position: "relative"
  },
  bottom: {
    position: "fixed",
    bottom: 24,
    width: 259,
    background: "#fff"
  },
  fullwidth: {
    width: "100%"
  }
});

interface IState {
  data: any
}

class NavSide extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    if (isAssetManager) {
      store.dispatch(loadSubscriptionRequestStart())
    }
  }

  public render() {
    const {  classes, showCommunitiesLink } = this.props;
    return (
      <List component="nav" className={classes.nav}>
        <ListItem button={true} component={DashboardLink}>
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Choose your role"
            primaryTypographyProps={{
              variant: "title"
            }}
          />
        </ListItem>

        <ListItem className={classes.indent} button={true} disabled={!isAdmin} component={SubscriptionLink}>
          <ListItemIcon>
            <CreditCardIcon />
          </ListItemIcon>
          <ListItemText primary="Data user" />
        </ListItem>

        <ListItem className={classes.indent} button={true} disabled={!isAdmin} component={DatamanagementLink}>
          <ListItemIcon>
            <LockIcon />
          </ListItemIcon>
          <ListItemText primary="Data provider" />
        </ListItem>

        <ListItem className={classes.indent} button={true} disabled={!isAssetManager} component={VerificationLink}>
            <ListItemIcon>
              <AppsIcon />
            </ListItemIcon>
            <ListItemText primary="Asset owner" />
        </ListItem>
          
        <ListItem className={classes.indent} button={true} disabled={!isAdmin} component={OrganizationLink}>
          <ListItemIcon>
            <BusinessIcon />
          </ListItemIcon>
          <ListItemText primary="My Organization" />
        </ListItem>

        <ListItem className={classes.indent} button={true} disabled={!isBillingAdmin} component={BillingLink}>
          <ListItemIcon>
            <BillingIcon />
          </ListItemIcon>
          <ListItemText primary="Billing" />
        </ListItem>

        {showCommunitiesLink &&
          <ListItem className={classes.indent} button={true} component={CommunitiesLink}>
            <ListItemIcon>
              <PeopleIcon/>
            </ListItemIcon>
            <ListItemText primary="Commmunity Management"/>
          </ListItem>
        }
        
        <ListItem className={classes.bottom} disableGutters>
          <List className={classes.fullwidth}>                           
            <ListItem button={true} component="a" target="_blank" href="http://status.nxtport.com">
              <ListItemIcon>
                <HealingIcon />
              </ListItemIcon>
              <ListItemText primary="Statuspage" />
            </ListItem>

            <ListItem button={true} component="a" target="_blank" href="https://nxtport.atlassian.net/servicedesk/customer/portal/1">
              <ListItemIcon>
                <ChatIcon />
              </ListItemIcon>
              <ListItemText primary="Support" />
            </ListItem>
           </List>
          </ListItem>
      </List>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    data: state,
  };
}

function mapDispatchToProps(dispatch: any) {
  return bindActionCreators(
    { loadSubscriptionRequestsSuccess },
    dispatch
  );
}

export default connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(NavSide));



// WEBPACK FOOTER //
// ./src/modules/core/components/nav-side/NavSide.tsx